import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import Lottie from 'lottie-react';
import React from 'react';
import { introCentered } from '../../lottie';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: 900,
    },
  },
  root: {
    marginTop: 143,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    maxWidth: '600px',
    overflow: 'hidden',
  },
  image: {
    zIndex: 4,
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'center',
    },
    [theme.breakpoints.between('xs', 'sm')]: {
      alignSelf: 'center',
      marginLeft: 0,
    },
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'center',
    },
  },
  left: {
    alignSelf: 'stretch',
    fontSize: '18px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
    zIndex: 4,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 20,
      paddingRight: 20,
      marginTop: 100,
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: 160,
    },
  },
  header: {
    zIndex: 2,
    alignSelf: 'center',
    position: 'absolute',
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto',
      width: 500,
      top: 30,
    },
    [theme.breakpoints.up('xs')]: {
      margin: '0 auto',
      width: 500,
      top: 40,
    },
    [theme.breakpoints.up('sm')]: {
      width: 600,
      top: 60,
    },
    [theme.breakpoints.up('md')]: {
      top: 40,
      left: -70,
      width: 700,
    },
  },
}));

export const Intro = () => {
  const { container, root, left, header, image } = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <div className={container}>
      <div className={root}>
        <img
          className={image}
          width="200"
          src={process.env.PUBLIC_URL + "/images/google_cloud_logo.png"}
          alt="google cloud logo"
        />
        <Lottie className={header} animationData={introCentered} />
        <div className={left}>
          <p
            style={{
              textAlign: matches ? 'center' : 'center',
              padding: matches ? undefined : '0 10px',
            }}
          >
            {matches
              ? `Change is constant. In order to stay ahead of it, you need data that
            gives you smarter, faster actionable insights. With a comprehensive
            platform that works across your entire data lifecycle and
            organization, you can break down silos, increase agility, innovate
            faster, and securely support business transformation.`
              : `Stay ahead of change. Change is constant. Take our 2 minute assessment to see where you are on the data intellegence journey.`}
          </p>
          {matches ? (
            <p>
              Take our 2 minute assessment to see where you're at on the data
              intelligence journey—and get a free guide to help you take the
              next step.
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};
